import React from 'react';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const SCHEDULE_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.SCHEDULE_AREA,
        title: 'Schedule',
        placement: 'right',
        borderRadius: 18,
        content: (
            <>
                Schedule is the date and time ranges during which the product is
                made available to the customers.
            </>
        ),
    },
    {
        className: OnboardingClasses.DURATION,
        title: 'Duration',
        placement: 'right',
        borderRadius: 28,
        content: (
            <>
                Duration indicates how long is the service from the start to the
                end.
            </>
        ),
    },
    {
        className: OnboardingClasses.POTENTIAL_OVERTIME,
        title: 'Potential Overtime',
        placement: 'right',
        borderRadius: 28,
        content: (
            <>
                Sometimes its hard to be on schedule because of factors that you
                don&#39;t control, for example road construction.
                <br />
                Potential overtime will indicate the potential variance that may
                occur (wherever applicable)
            </>
        ),
    },
    {
        className: OnboardingClasses.ADD_SCHEDULE_ITEM,
        title: 'Add Schedule Item',
        nextOnTargetClick: true,
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                Schedule items constitute the full schedule of you product from
                ranges and discrete dates.
                <br />
                <b>Season</b> - Select this if the schedule item will cover a
                range of dates.
                <br />
                <b>Custom dates</b> - Select this if you want to pick one or
                more precise dates, that are scattered over time.
                <br />
                <b>Browse</b> - Select this if you already created a schedule
                item and want to reuse it
            </>
        ),
    },
];
